var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('div', {
    staticClass: "s-container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "custom-elanco-header"
  }, [_c('span', {
    staticClass: "custom-elanco-header__text"
  }, [_vm._v("Hi " + _vm._s(_vm.deepGet(_vm.user, 'name')))]), _c('a', {
    attrs: {
      "href": _vm.deepGet(_vm.event, 'config.header_logo_url', '#')
    }
  }, [_vm.deepGet(_vm.event, 'config.images.header_logo') ? _c('img', {
    staticClass: "custom-elanco-header__image ml-3",
    attrs: {
      "src": _vm.deepGet(_vm.event, 'config.images.header_logo')
    }
  }) : _vm._e()])]), !_vm.isLoading ? _c('div', {
    staticClass: "content__success"
  }, [_vm.successfullyApplied ? [_vm.event.config.images ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.event.config.images.redeem_success,
      "alt": "Elanco"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "py-3 px-4"
  }, [_c('div', {
    staticClass: "text-center py-3 content__success__title"
  }, [_vm._v(_vm._s(_vm.deepGet(_vm.event, 'config.expo_2025.applied_success_message', '兌換券領取成功')))]), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToCouponList
    }
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.event, 'config.expo_2025.applied_success_button_text', '查看回饋詳情')) + " ")])])] : [_vm.event.config.images ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.event.config.images.redeem_confirm_kv,
      "alt": "Elanco"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "py-3 px-4"
  }, [_c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToCouponList
    }
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.event, 'config.member_center_text', '返回會員專區')) + " ")])])]], 2) : _vm._e()])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }